import React from 'react'
import HistoryTextBox from './HistoryTextBox'
import HistoryViewButton from './HistoryViewButton'
import allImgPaths from 'assets/images'
import HistoryFileUpload from './HistoryFileUpload';
import { format } from 'date-fns';

interface CardsAndBlocksProps {
    activityIcon?: any;
    data: any;
    period: any
}

const CardsAndBlocks = ({ activityIcon, data, period }: CardsAndBlocksProps) => {
    const handleImageError = (e: any) => {
        e.target.src = allImgPaths.defaultProfile
    }

    return (
        <>
            <div className="px-3 pt-3 pb-4 mb-5 last:pb-3 last:mb-0 border-b border-[#F1F1F1] last:border-b-transparent">
                <div className="flex gap-x-4 mb-4">
                    <div className="relative w-10">
                        <img className="min-w-10 h-10 rounded-full" onError={handleImageError} src={data?.user?.profile_image || allImgPaths.defaultProfile} alt="" />
                        <img
                            className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full"
                            src={allImgPaths.historyDate}
                            alt=""
                        />
                    </div>

                    <div className="leading-none">
                        <div className="font-interMedium text-base text-[#4F4D55] pb-0.5">
                            <span className="font-interMedium text-base text-[#0A090B]">
                                {data?.action_data?.action_user?.name || 'A user'}
                            </span>

                            {
                                data?.action_data?.fields === 'card-status-change' &&
                                <>
                                    <span> changed&nbsp;
                                        <span className="font-interMedium text-base text-[#0A090B]">{data?.card?.title} </span>
                                        card status from </span>
                                    <span className="font-interMedium text-base text-[#1751D0]"> {data?.action_data?.old_value} </span>
                                    <span> to </span>
                                    <span className="font-interMedium text-base text-[#1751D0]"> {data?.action_data?.new_value} </span>
                                </>
                            }
                            {
                                data?.action_data?.fields === 'update-position' &&
                                <>
                                    <span> changed position of </span>
                                    {
                                        data?.action_data?.new_value == 'block-position-changed' &&
                                        <span className="font-interMedium text-base text-[#0A090B]"> blocks </span>
                                    }

                                </>
                            }

                        </div>
                        <div className="leading-none flex items-center gap-x-2.5">
                            {/* <span className="text-xs text-[#7F7D83]">{format(data?.createdAt, 'hh:mm a')}</span> */}
                            {
                                (period == 'Today' || period == 'Yesterday') &&
                                <span className="text-xs text-[#7F7D83]">
                                    {format(data?.createdAt, 'hh:mm a')}
                                </span>
                            }
                            {
                                period != 'Today' && period != 'Yesterday' &&
                                <span className="text-xs text-[#7F7D83]">
                                    {format(data?.createdAt, 'EEEE, MMM dd yyyy, hh:mm a')}
                                </span>
                            }
                            {
                                data?.block?.title && data?.card?.title &&
                                <>
                                    <span className="w-1 h-1 bg-[#7F7D83] rounded-full block"></span>
                                    <span className="text-xs text-[#7F7D83]">
                                        {data?.block?.title} / {data?.card?.title}
                                    </span>

                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CardsAndBlocks